import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

const HIBERNATION_SCHEDULES_QUERY_KEY = 'hibernation-schedules';

export const getHibernationSchedulesQueryKey = (organizationId: string) =>
  [HIBERNATION_SCHEDULES_QUERY_KEY, organizationId] as const;

const getHibernationSchedulesQueryOptions = (organizationId: string) =>
  queryOptions({
    queryKey: getHibernationSchedulesQueryKey(organizationId),
    queryFn: async () => {
      const { data } =
        await apiClient.clusterAutoscaler.getHibernationSchedules({
          organizationId,
        });

      return data.items || [];
    },
    enabled: !!organizationId,
  });

export const useGetHibernationSchedulesQuery = ({
  clusterId,
}: { clusterId?: string } = {}) => {
  const { currentOrganization } = useOrganizations();
  const currentOrganizationId = currentOrganization?.id ?? '';

  const {
    data: hibernationSchedules,
    isLoading,
    error,
    refetch,
  } = useQuery({
    ...getHibernationSchedulesQueryOptions(currentOrganizationId),
    select: (data) => {
      if (!clusterId) {
        return data;
      }

      return data.filter((schedule) =>
        schedule.clusterAssignments.items.some(
          (assignment) => assignment.clusterId === clusterId
        )
      );
    },
  });

  return {
    hibernationSchedules,
    isLoading,
    error,
    refetch,
  };
};
